import React, { useEffect, useState } from 'react';
import Blog from './Blog';
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Link,
    useParams
  } from "react-router-dom";
import './App.css'
import Loading from './core/Loading';
import Article from './pages/article';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Header from './Header';
import Footer from './Footer';
import NewsBlog from './news/article';
import News from './News';
import { Helmet } from 'react-helmet';


export default function App(props) {
    const [mounted, setmounted] = useState(false)
    const { posts } = props;
    const [loading, setLoading] = useState(true)
    const [token, setToken] = useState('');
    const theme = createTheme();
    const sections = [
        // { title: 'Technology', url: '#' },
        // { title: 'Design', url: '#' },
        // { title: 'Culture', url: '#' },
        // { title: 'Business', url: '#' },
        // { title: 'Politics', url: '#' },
        // { title: 'Opinion', url: '#' },
        // { title: 'Science', url: '#' },
        // { title: 'Health', url: '#' },
        // { title: 'Style', url: '#' },
        // { title: 'Travel', url: '#' },
      ];
    useEffect(() => {
        setLoading(true)
        setToken(document.querySelector('meta[name="csrf-token"]').getAttribute('content'))
        localStorage.setItem('token', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
        setmounted(true)
        setLoading(false)
    }, [])

    if (loading || !mounted) {
        return (<Loading width={"100%"} />)
    }
    return (
        <Router>
             <ThemeProvider theme={theme} >
                <CssBaseline />
                <Container maxWidth="xlg">
                <Header title="RealLexi | The Real Word" sections={sections} />
        <main>
            <Routes>
                <Route path="/v2" element={<Blog />} />
                <Route path="/v2/news" element={<News />} />
                <Route path="/v2/article/:path" element={<Article />} />
                <Route path="/" element={<Blog />} />
                <Route path="/news" element={<News />} />
                <Route path="/article/:path" element={<Article />} />
                <Route path="/v2/news/:path" element={<NewsBlog />} />
                <Route path="/news/:path" element={<NewsBlog />} />
            </Routes>
        </main>
            </Container>
            <Footer
                title="Footer"
                description="The Real Word"
            />
            </ThemeProvider>
        </Router>

    );
}






